module.exports = __webpack_public_path__ + "img/07.588a932a.jpg";